// Old movies — public-domain films streamed from the Internet Archive's own player (archive.org/embed).
// We host nothing. Every identifier verified 2026-09-08 on the IA metadata API (h.264 / MPEG4 derivative present).
export const FILMS = [
  // ——— horror ———
  { id: 'notld', ia: 'night_of_the_living_dead_dvd', title: 'Night of the Living Dead', year: 1968, mins: 96, group: 'horror',
    blurb: 'the movie that invented the zombie. lost its copyright on day one. free forever.' },
  { id: 'nosferatu', ia: 'Nosferatu_DVD_quality', title: 'Nosferatu', year: 1922, mins: 94, group: 'horror',
    blurb: 'a symphony of horror. the first vampire. still the scariest one.' },
  { id: 'carnival', ia: 'CarnivalofSouls', title: 'Carnival of Souls', year: 1962, mins: 83, group: 'horror',
    blurb: 'one organist, one abandoned pavilion, $33,000. cult forever.' },
  { id: 'lastman', ia: 'TheLastManOnEarth_72', title: 'The Last Man on Earth', year: 1964, mins: 86, group: 'horror',
    blurb: 'vincent price alone on earth. i am legend, the first time.' },
  { id: 'haunted', ia: 'HouseOnHauntedHill1959', title: 'House on Haunted Hill', year: 1959, mins: 75, group: 'horror',
    blurb: 'vincent price offers $10,000 to survive the night. william castle. the skeleton.' },
  { id: 'caligari', ia: 'DasKabinettdesDoktorCaligariTheCabinetofDrCaligari', title: 'The Cabinet of Dr. Caligari', year: 1920, mins: 51, group: 'horror',
    blurb: 'german expressionism. painted shadows. the first twist ending.' },
  { id: 'phantom', ia: 'ThePhantomOfTheOpera_201612', title: 'The Phantom of the Opera', year: 1925, mins: 93, group: 'horror',
    blurb: 'lon chaney. the unmasking. audiences fainted. (real)' },
  { id: 'terror', ia: 'TheTerror1963', title: 'The Terror', year: 1963, mins: 79, group: 'horror',
    blurb: 'boris karloff and a 26-year-old jack nicholson. shot in leftover sets in four days.' },
  { id: 'brain', ia: 'brain_that_wouldnt_die', title: "The Brain That Wouldn't Die", year: 1962, mins: 82, group: 'horror',
    blurb: 'a head in a pan. a thing in the closet. mst3k royalty.' },
  { id: 'leeches', ia: 'cco_attackofthegiantleeches', title: 'Attack of the Giant Leeches', year: 1959, mins: 62, group: 'horror',
    blurb: 'roger corman. the swamp. the leeches are men in trash bags. perfect.' },
  { id: 'shrews', ia: 'The_Killer_Shrews', title: 'The Killer Shrews', year: 1959, mins: 69, group: 'horror',
    blurb: 'dogs in shag carpets. an island. a hurricane. the shrews.' },
  { id: 'lsoh', ia: 'TheLittleShopOfHorrors1960_765', title: 'The Little Shop of Horrors', year: 1960, mins: 72, group: 'horror',
    blurb: 'feed me. shot in two days. jack nicholson at the dentist.' },

  // ——— sci-fi ———
  { id: 'plan9', ia: 'plan-9-from-outer-space', title: 'Plan 9 from Outer Space', year: 1959, mins: 79, group: 'scifi',
    blurb: 'ed wood. the worst movie ever made. therefore essential.' },
  { id: 'metropolis', ia: 'Metropolis1927EnglishVersion', title: 'Metropolis', year: 1927, mins: 118, group: 'scifi',
    blurb: 'the city of the future, 1927. every sci-fi movie is downstream of this.' },
  { id: 'moon', ia: 'ATripToTheMoon1902', title: 'A Trip to the Moon', year: 1902, mins: 14, group: 'scifi',
    blurb: 'méliès. the rocket in the moon\'s eye. the first sci-fi film. fourteen minutes.' },
  { id: 'teenagers', ia: 'teenagers_from_outerspace', title: 'Teenagers from Outer Space', year: 1959, mins: 86, group: 'scifi',
    blurb: 'a ray gun that turns you into a skeleton. lobster monster. $14,000 budget.' },
  { id: 'santa', ia: 'SantaClausConquerstheMartians1964', title: 'Santa Claus Conquers the Martians', year: 1964, mins: 81, group: 'scifi',
    blurb: 'exactly what it says. the martians kidnap santa. children love it. adults suffer.' },
  { id: 'lostworld', ia: 'TheLostWorld512', title: 'The Lost World', year: 1925, mins: 64, group: 'scifi',
    blurb: 'stop-motion dinosaurs in 1925. willis o\'brien, before king kong.' },

  // ——— noir ———
  { id: 'detour', ia: 'Detour1945_201808', title: 'Detour', year: 1945, mins: 68, group: 'noir',
    blurb: 'six days, one road, a hitchhiker. the cheapest masterpiece in film noir.' },
  { id: 'doa', ia: 'DOA1950', title: 'D.O.A.', year: 1950, mins: 83, group: 'noir',
    blurb: '"i want to report a murder." "who was murdered?" "i was."' },
  { id: 'scarlet', ia: 'ScarletStreet', title: 'Scarlet Street', year: 1945, mins: 103, group: 'noir',
    blurb: 'fritz lang. edward g. robinson. a painter, a con, the rain.' },
  { id: 'devil', ia: 'BeatTheDevil1953', title: 'Beat the Devil', year: 1953, mins: 89, group: 'noir',
    blurb: 'bogart. huston. truman capote writing the script day by day. a joke nobody got in 1953.' },

  // ——— comedy & classics ———
  { id: 'friday', ia: 'his_girl_friday', title: 'His Girl Friday', year: 1940, mins: 92, group: 'comedy',
    blurb: 'the fastest dialogue ever recorded. cary grant. no one finishes a sentence.' },
  { id: 'godfrey', ia: 'MyManGodfrey1936', title: 'My Man Godfrey', year: 1936, mins: 95, group: 'comedy',
    blurb: 'a rich family adopts a "forgotten man" from the dump as their butler. screwball peak.' },
  { id: 'johndoe', ia: 'meet_john_doe', title: 'Meet John Doe', year: 1941, mins: 123, group: 'comedy',
    blurb: 'capra. a fake letter to the editor becomes a movement. the internet, 1941.' },
  { id: 'charade', ia: 'charade_202604', title: 'Charade', year: 1963, mins: 113, group: 'comedy',
    blurb: 'cary grant and audrey hepburn in paris. public domain because someone forgot the © symbol. (real)' },
  { id: 'mclintock', ia: 'mclintok_widescreen', title: 'McLintock!', year: 1963, mins: 127, group: 'comedy',
    blurb: 'john wayne. maureen o\'hara. the mud fight.' },
  { id: 'sherlock', ia: 'sherlockjr1924_201909', title: 'Sherlock Jr.', year: 1924, mins: 45, group: 'comedy',
    blurb: 'buster keaton walks into the movie screen. 1924. nobody has topped it.' },

  // ——— cartoons & silent ———
  { id: 'willie', ia: 'steamboat-willie_1928', title: 'Steamboat Willie', year: 1928, mins: 8, group: 'toons',
    blurb: 'the mouse. public domain since january 2024. the internet celebrated.' },
  { id: 'gulliver', ia: 'GulliversTravels1939_201509', title: "Gulliver's Travels", year: 1939, mins: 76, group: 'toons',
    blurb: 'the fleischer feature. lilliput vs blefuscu over a wedding song.' },
  { id: 'potemkin', ia: 'BattleshipPotemkin', title: 'Battleship Potemkin', year: 1925, mins: 73, group: 'toons',
    blurb: 'the odessa steps. every film school. every editing class. the pram.' },
  { id: 'reefer', ia: 'reefer_madness1938', title: 'Reefer Madness', year: 1936, mins: 68, group: 'toons',
    blurb: 'the anti-weed propaganda film that became a midnight movie. rediscovered in 1971. cult.' },
];

export const FILM_GROUPS = [
  { id: 'horror', label: 'Horror' },
  { id: 'scifi', label: 'Sci-fi' },
  { id: 'noir', label: 'Film noir' },
  { id: 'comedy', label: 'Comedy & classics' },
  { id: 'toons', label: 'Silent, cartoons & cult' },
];

export const posterOf = f => `https://archive.org/services/img/${f.ia}`;
export const embedOf = f => `https://archive.org/embed/${f.ia}`;
export const pageOf = f => `https://archive.org/details/${f.ia}`;
export const findFilm = q => {
  const s = String(q || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  if (!s) return null;
  return FILMS.find(f => f.id === s) || FILMS.find(f => f.title.toLowerCase().replace(/[^a-z0-9]/g, '').includes(s)) || null;
};
